import React from 'react';
import { CardComponentProps } from './types';

/**
 * Card footer component for use with the Card component
 */
export const CardFooter: React.FC<CardComponentProps> = ({
  children,
  className = '',
}) => (
  <div className={`p-4 border-t bg-neutral-50 ${className}`}>{children}</div>
);
